import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, FileText, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-white py-16 mt-auto" data-id="element-99">
      <div className="max-w-7xl mx-auto px-6" data-id="element-100">
        <div className="flex flex-col gap-12" data-id="element-101">
          {/* Top: Branding and Tagline */}
          <div className="text-center" data-id="element-102">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-green-500/20 text-green-400 rounded-full text-xs font-medium mb-6" data-id="element-103">
              <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-104" />
              Open to opportunities
            </div>
            <h2 className="text-3xl md:text-4xl font-thin mb-4" data-id="element-105">
              Let's build something meaningful together
            </h2>
            <p className="text-slate-400 font-light max-w-2xl mx-auto mb-8" data-id="element-106">
              I'm looking for a team that values collaborative culture, having
              fun, and making a real difference in the world.
            </p>
          </div>

          {/* Contact Information - Single Row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-107">
            <div className="flex flex-col items-center text-center" data-id="element-108">
              <Mail className="text-blue-400 mb-3" size={24} data-id="element-109" />
              <h3 className="font-medium mb-1" data-id="element-110">Email</h3>
              <a href="mailto:hello@rebeccalordux.com" className="text-slate-300 hover:text-white transition-colors font-light" data-id="element-111">
                hello@rebeccalordux.com
              </a>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-112">
              <Linkedin className="text-blue-400 mb-3" size={24} data-id="element-113" />
              <h3 className="font-medium mb-1" data-id="element-114">LinkedIn</h3>
              <a href="https://www.linkedin.com/in/relord" className="text-slate-300 hover:text-white transition-colors font-light" data-id="element-115">
                Connect with me
              </a>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-116">
              <MapPin className="text-blue-400 mb-3" size={24} data-id="element-117" />
              <h3 className="font-medium mb-1" data-id="element-118">Location</h3>
              <p className="text-slate-300 font-light" data-id="element-119">Massachusetts, USA</p>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-120">
              <FileText className="text-blue-400 mb-3" size={24} data-id="element-121" />
              <h3 className="font-medium mb-1" data-id="element-122">Resume</h3>
              <a href="https://drive.google.com/file/d/1JkohzcmpUul7p0pN-sH1hINJczIXNqNs/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors font-light" data-id="element-123">
                Download PDF
              </a>
            </div>
          </div>

          {/* Bottom: Copyright */}
          <div className="text-center pt-8 border-t border-slate-800" data-id="element-124">
            <p className="text-slate-400 text-sm font-light" data-id="element-125">
              © 2026 Rebecca Lord. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}